<div class="container mx-auto p-2">
  <div class="text-2xl text-center my-4 text-gray-800" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Soil Data
    Inspection</div>

  <div class="bg-green-50 border border-green-200 rounded-lg p-4 my-4 shadow-md">
    <p class="text-gray-700 font-medium">
      Use the map to select a location by clicking on it. The coordinates will update the Selected Soil Data fields
      avaiable. <br> <br>
      Fields for <strong>Phosphorus (P)</strong>, <strong>Potassium (K)</strong>, <strong>Crop Type</strong>,
      <strong>Farming System</strong>, <strong>Area of farm</strong> and <strong>Yield</strong> are also required to be
      filled in by the user. <br> <br> Once complete, you can save the location to
      <em>My Soil Data</em> for future use, by checking the box "Add to My Soil Data".
      <br> <br> Selecting this option saves the edited values currently shown in the table. Once saved, the locations can be retrieved from the left side of the page.
      <br> <br> Then, you can choose an action for the Soil Data in use between:
      <strong>Predictions</strong>,
      <strong>Economic Values</strong> and <strong>Benchmarking</strong>. <br> <br> Alternatively, select a dataset from
      saved data to perform these actions.
    </p>
  </div>
  <div class="text-gray-600 italic text-center mb-4">
    Details on the fields are provided below.
  </div>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4 font-light">

    <div class="col-span-1 space-y-4">
      <div class="bg-white rounded-lg shadow-md p-4">
        <div class="text-xl mb-4" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Climate</div>
        <div class="my-2">
          <div class="text-lg" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Mean Temperature</div>
          <div class="ml-2">Base index representing the average air temperature over 3 days.</div>
        </div>
        <div class="mt-2">
          <div class="text-lg" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Total Precipitation</div>
          <div class="ml-2">Sum of rainfall and the assumed water equivalent of snowfall for a 3-day period.</div>
        </div>
      </div>

      <div class="bg-white rounded-lg shadow-md p-4">
        <div class="text-xl mb-4" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Soil Nutrients</div>
        <div class="my-2">
          <div class="text-lg" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Nitrogen (N)</div>
          <div class="ml-2">Total Nitrogen (N)</div>
        </div>
        <div class="my-2">
          <div class="text-lg" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Phosphorus</div>
          <div class="ml-2">Total Phosphorus (P)</div>
        </div>
        <div class="mt-2">
          <div class="text-lg" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Potassium</div>
          <div class="ml-2">Total Potassium (K)</div>
        </div>
      </div>
    </div>
    <div class="col-span-1 bg-white rounded-lg shadow-md p-4">
      <div class="text-xl mb-4" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Field Properties</div>
      <div class="my-2">
        <div class="text-lg" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Soil Texture</div>
        <div class="ml-2">Refers to the proportion of sand, silt and clay sized particles that make up the mineral
          fraction of the soil.</div>
      </div>
      <div class="my-2">
        <div class="text-lg" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Clay</div>
        <div class="ml-2">Proportion of clay particles (< 0.002 mm) in the fine earth fraction.</div>
        </div>
        <div class="my-2">
          <div class="text-lg" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Sand</div>
          <div class="ml-2">Proportion of sand particles (> 0.05 mm) in the fine earth fraction.</div>
        </div>
        <div class="my-2">
          <div class="text-lg" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Silt</div>
          <div class="ml-2">Proportion of silt particles (≥ 0.002 mm and ≤ 0.05 mm) in the fine earth fraction.</div>
        </div>
        <div class="my-2">
          <div class="text-lg" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Soil Organic Carbon</div>
          <div class="ml-2">Soil organic carbon content in the fine earth fraction.</div>
        </div>
        <div class="my-2">
          <div class="text-lg" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Organic Carbon Density</div>
          <div class="ml-2">Organic carbon density of the fine earth fraction.</div>
        </div>
        <div class="my-2">
          <div class="text-lg" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">Bulk Density</div>
          <div class="ml-2">Bulk density of the fine earth fraction.</div>
        </div>
        <div class="mt-2">
          <div class="text-lg" style="text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);">PH</div>
          <div class="ml-2">Soil PH.</div>
        </div>
      </div>
    </div>
  </div>